const actions = {
  SET_SCHEDULE_MODAL_OPEN: "SET_SCHEDULE_MODAL_OPEN",
  SET_SCHEDULE_MODAL_DATA: "SET_SCHEDULE_MODAL_DATA",
  RESET_SCHEDULE_MODAL: "RESET_SCHEDULE_MODAL",
  openModal: (state) => ({
    type: actions.SET_SCHEDULE_MODAL_OPEN,
    payload: { state },
  }),
  setData: (data) => ({
    type: actions.SET_SCHEDULE_MODAL_DATA,
    payload: { data },
  }),
  reset: () => ({
    type: actions.RESET_SCHEDULE_MODAL,
  }),
};
export default actions;
